import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { ConfigurationModel } from "../models/ConfigurationModels/ConfigurationModel";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bbsf-utilities";

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {
  ApiUrl = "/api/admin/Configuration/"
  constructor(private http: RequestHandlerService) {
  }

  AddConfiguration(AddModel: ConfigurationModel) {
   
    return this.http.post( this.ApiUrl + 'AddConfiguration', AddModel);
  }
  GetEditConfiguration( id: string) {
 
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.get( this.ApiUrl + 'EditConfiguration', params);

  }
  EditConfiguration(EditModel: ConfigurationModel) {
   
    return this.http.post( this.ApiUrl + 'EditConfiguration', EditModel);
  }
  DeleteConfiguration(UsersIDRequestModel: UsersIDRequestModel) {
    return this.http.post( this.ApiUrl + 'DeleteConfiguration', UsersIDRequestModel);
  }
  Loaddropdowns() {

    return this.http.get( this.ApiUrl + 'Loaddropdowns');
  }
  LoadLookupItems( Id: string) {
    let params = new HttpParams();
    params = params.append("id", Id);
    return this.http.post( this.ApiUrl + 'LoadLookupItems', null, params);
  }

  LoadSourceFunctionDropDownItems( sourceFunc: string) {
;
    return this.http.get( this.ApiUrl + sourceFunc, null);

  }


}
